import { render, staticRenderFns } from "./foot2022.vue?vue&type=template&id=02ff15a2&scoped=true"
import script from "./foot2022.vue?vue&type=script&lang=js"
export * from "./foot2022.vue?vue&type=script&lang=js"
import style0 from "./foot2022.vue?vue&type=style&index=0&id=02ff15a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ff15a2",
  null
  
)

export default component.exports